import React from "react";

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-black text-white p-8 overflow-y-auto">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-6">Superbot Terms of Service</h1>

        <p className="mb-4">
          By creating an account on Superbot, you acknowledge that you have
          read, understood, and agreed to these Terms of Service.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">No Financial Advice</h2>
        <p className="mb-4">
          Superbot provides automated trading tools and does not provide
          financial advice or guarantee profits.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">Risk Disclosure</h2>
        <p className="mb-4">
          Cryptocurrency trading involves substantial risk including total loss
          of capital. Automated systems may malfunction or execute trades
          unexpectedly.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">Platform Availability</h2>
        <p className="mb-4">
          The platform may be offline temporarily due to maintenance, updates,
          or technical issues. We do not guarantee uninterrupted uptime.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">Modifications</h2>
        <p className="mb-4">
          We reserve the right to modify these terms and platform features at
          any time. Continued use constitutes acceptance of updates.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">Limitation of Liability</h2>
        <p>
          Superbot and its developers are not liable for trading losses,
          service interruptions, or exchange-related failures.
        </p>
      </div>
    </div>
  );
};

export default TermsPage;
